import {Spinner, Switch} from "../atoms";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {SettingsApi} from "../../api/Settings.api";
import {useProfile} from "../../hooks";

export const SwitchAutoRetry = () => {
    const queryClient = useQueryClient();
    const profile = useProfile();
    const isEditable = profile?.permissions.includes('settings.edit');

    const {data: settingData, isLoading} = useQuery({
        queryKey: [SettingsApi.KEY, 'settings.withdrawal.retry.auto.enable'],
        queryFn: () => SettingsApi.getSettingValue('settings.withdrawal.retry.auto.enable'),
    });

    const autoRetryEnabled = settingData?.value === "true";

    const [enabled, setEnabled] = useState(autoRetryEnabled);

    useEffect(() => {
        setEnabled(autoRetryEnabled);
    }, [autoRetryEnabled]);

    const toggleAutoRetryMutation = useMutation({
        mutationFn: (newValue: boolean) =>
            SettingsApi.setSettingValue({
                setting: 'settings.withdrawal.retry.auto.enable',
                value: newValue.toString()
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [SettingsApi.KEY, 'settings.withdrawal.retry.auto.enable']
            });
        },
        onError: () => {
            setEnabled(!enabled);
        }
    });

    const handleToggle = () => {
        const newValue = !enabled;
        setEnabled(newValue);
        toggleAutoRetryMutation.mutate(newValue);
    };

    if (isLoading) {
        return <Spinner/>;
    }

    return (
        <div className="flex gap-2 items-center relative !outline-none">
            <span>Auto retry:</span>
            <Switch
                disabled={!isEditable || toggleAutoRetryMutation.isPending}
                checked={enabled}
                onClick={handleToggle}
            />
            {toggleAutoRetryMutation.isPending && <Spinner />}
        </div>
    );
};